import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddOldCarFlow.css";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { useDispatch } from "react-redux";
import { close_snack_bar } from "../../Common/snackbar/action";
import StepIndicator from "./Common/StepIndicator";
import { Upload, X } from "lucide-react";

export default function CarInfoCards(props) {
  const dispatch = useDispatch();
  const [image, setImage] = useState([]);
  const [brand, setBrand] = useState("");
  const [carName, setCarName] = useState("");
  const [fuelType, setFuelType] = useState("");
  const [carType, setCarType] = useState("");
  const [price, setPrice] = useState("");
  const [discountedPrice, setDiscountedPrice] = useState("");
  const [kilometer, setKilometer] = useState("");

  const navigate = useNavigate();

  const carBrands = [
    "Aston Martin", "Audi", "Bentley", "BMW", "BYD", "Chevrolet", "Datsun", "Ferrari", "Fiat", "Fisker", "Ford", "Great Wall Motors",
    "Honda", "Hyundai", "Isuzu", "Jaguar", "Jeep", "Kia", "Koenigsegg", "Lamborghini", "Land Rover", "Lexus", "Lotus", "Mahindra",
    "Maruti Suzuki", "Maserati", "McLaren", "Mercedes-Benz", "MG Motor", "Nissan", "Ora", "Pagani", "Polestar", "Porsche", "Renault",
    "Rolls-Royce", "Skoda", "Tata Motors", "Tesla", "Toyota", "Volkswagen", "Volvo"
  ];

  const handleImageChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setImage((prev) => [...prev, ...selectedFiles]);
  };

  const removeImage = (index) => {
    setImage((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const imagesData = image.map((img, index) => ({ [`image${index + 1}`]: img }));
    props.addOldCar(
      props.login.token,
      props.login.user_id,
      brand,
      carName,
      fuelType,
      carType,
      price,
      discountedPrice,
      kilometer,
      imagesData
    );
    navigate("/overview");
  };

  return (
    <div className="old-car-flow-container">
      <StepIndicator currentStep={1} />

      <div className="old-car-flow-card">
        <h2 className="flow-title">Basic Information</h2>
        <p className="flow-subtitle">Start by adding the main details and images of the vehicle</p>

        <form onSubmit={handleSubmit} className="flow-form">
          {/* Image Upload */}
          <div className="flow-group full-width">
            <label className="flow-label">Vehicle Images</label>
            <label className="image-upload-wrapper">
              <Upload className="upload-icon" size={32} />
              <div style={{ fontWeight: 600, color: 'var(--text-main)', marginBottom: '4px' }}>Click to upload images</div>
              <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>Support for JPG, PNG. Max 10 images.</div>
              <input type="file" multiple onChange={handleImageChange} style={{ display: 'none' }} />
            </label>

            {image.length > 0 && (
              <div className="image-preview-grid">
                {image.map((img, idx) => (
                  <div key={idx} className="preview-img-container">
                    <img src={URL.createObjectURL(img)} alt={`Preview ${idx}`} />
                    <button
                      type="button"
                      onClick={() => removeImage(idx)}
                      style={{
                        position: 'absolute',
                        top: '4px',
                        right: '4px',
                        background: 'rgba(255,255,255,0.9)',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '2px',
                        cursor: 'pointer',
                        display: 'flex'
                      }}
                    >
                      <X size={14} color="#ef4444" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="flow-grid">
            <div className="flow-group">
              <label className="flow-label">Brand</label>
              <select className="flow-select" value={brand} onChange={(e) => setBrand(e.target.value)} required>
                <option value="">Select Brand</option>
                {carBrands.map((b) => <option key={b} value={b}>{b}</option>)}
              </select>
            </div>

            <div className="flow-group">
              <label className="flow-label">Car Name</label>
              <input className="flow-input" type="text" placeholder="e.g. MG Hector" value={carName} onChange={(e) => setCarName(e.target.value)} required />
            </div>

            <div className="flow-group">
              <label className="flow-label">Fuel Type</label>
              <select className="flow-select" value={fuelType} onChange={(e) => setFuelType(e.target.value)} required>
                <option value="">Select Fuel</option>
                <option value="Petrol">Petrol</option>
                <option value="Diesel">Diesel</option>
                <option value="CNG">CNG</option>
                <option value="Electric">Electric</option>
                <option value="Hybrid">Hybrid</option>
              </select>
            </div>

            <div className="flow-group">
              <label className="flow-label">Car Type</label>
              <select className="flow-select" value={carType} onChange={(e) => setCarType(e.target.value)} required>
                <option value="">Select Type</option>
                <option value="SUV">SUV</option>
                <option value="Sedan">Sedan</option>
                <option value="Hatchback">Hatchback</option>
              </select>
            </div>

            <div className="flow-group">
              <label className="flow-label">Price (₹)</label>
              <input className="flow-input" type="number" placeholder="Original Price" value={price} onChange={(e) => setPrice(e.target.value)} required />
            </div>

            <div className="flow-group">
              <label className="flow-label">Discounted Price (₹)</label>
              <input className="flow-input" type="number" placeholder="Selling Price" value={discountedPrice} onChange={(e) => setDiscountedPrice(e.target.value)} required />
            </div>

            <div className="flow-group full-width">
              <label className="flow-label">Kilometers Driven</label>
              <input className="flow-input" type="number" placeholder="e.g. 15000" value={kilometer} onChange={(e) => setKilometer(e.target.value)} required />
            </div>
          </div>

          <div className="flow-actions">
            <button type="submit" className="flow-btn-primary">Next Step</button>
          </div>
        </form>
      </div>

      <LoaderCon />
      <Snackbar1
        open={props.snackbar.response_received}
        close_snack_bar={() => dispatch(close_snack_bar())}
        message={props.snackbar.message}
      />
    </div>
  );
}

